<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <p>
      <!-- <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://1.envato.market/vuexy_admin" target="_blank" rel="nofollow">Pixinvent</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span> -->
      <span>{{ footer }}</span>
    </p>
    <span class="md:flex hidden items-center">
      <span>powered using Vise Studio</span>
      <feather-icon
      icon="HeartIcon"
      svgClasses="stroke-current text-danger w-6 h-6"
      class="ml-2"
      />
      <span> &nbsp;&nbsp;v2.156.0</span>
      <!-- <img src="/logo_vise_rodape.png" width="24px" height="24px" style="margin-top: -7px!important;margin-left: 6px!important"/> -->
    </span>
  </footer>
</template>

<script>
import store from "../../store/store";
import { getApplicationLocalStorageItem } from "../../helpers.js";
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    }
  },
  data() {
    return {
      footer: JSON.parse(getApplicationLocalStorageItem("web")).footer
    };
  }
};
</script>
